import { type AnimationControlValue, AnimationRadioGroup } from './AnimationRadioGroup';
import { loopingOptions, type AnimationLooping } from './animationControlOptions';

type AnimationLoopingControlProps = {
    value?: AnimationControlValue<AnimationLooping>;
    defaultValue?: AnimationControlValue<AnimationLooping>;
    onChange?: (value: AnimationControlValue<AnimationLooping>) => void;
};

const AnimationLoopingControl = (props: AnimationLoopingControlProps) => (
    <AnimationRadioGroup name='looping' options={loopingOptions} {...props} />
);

export default AnimationLoopingControl;
